import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

const Root = styled(Horizontal)`
  width: 100%;
  height: var(--half-unit);
  background-color: var(--c-nd-50);
  border-radius: var(--double-unit);
`;
const Filled = styled(Horizontal)`
  height: var(--half-unit);
  background-color: var(--c-white);
  border-radius: var(--double-unit);
`;

type Props = { progress: number };
export const ProgressBar = ({ progress }: Props) => {
  return (
    <Root>
      <Filled style={{ width: `${progress}%` }} />
    </Root>
  );
};
